import styled, { css } from 'styled-components';
import { ContainerCustom } from 'components';

export const ContainerInner = styled(ContainerCustom)`
  padding: ${({ padding }) => padding};

  ${({ theme, borderRight }) => borderRight
    && css`
      border-right: 1px solid ${theme.colors.borders.light};
      @media (max-width: 749px) {
        /* padding: 0 0 20px 0; */
        border-right: none;
        border-bottom: 1px solid ${theme.colors.borders.light};
      }
    `}
  @media (max-width: 749px) {
    text-align: center;
    padding: 0 0 20px 0;
  }
`;

export const ContactSelectStyles = styled.div`
  &&& {
    width: ${({ width }) => width};
    margin: ${({ margin }) => margin};

    select:active,
    select:hover {
      outline-color: red;
    }
    .ant-select-selection-item {
      color: #9791a7 !important;
    }
    .ant-select-focused .ant-select-selector,
    .ant-select-selector:focus,
    .ant-select-selector:active,
    .ant-select-selector:hover,
    .ant-select-open .ant-select-selector {
      border-color: #d7d6e0 !important;
      box-shadow: none !important;
      color: #9791a7;
      padding-left: 20px !important;
      font-weight: normal;
      font-size: 16px;
      line-height: 140%;
    }
    .ant-picker,
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      /* width: 100%; */
      font-weight: normal;
      font-size: 16px;
      line-height: 140%;
      padding-left: 20px !important;

      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
    }
  }
`;
